<div class="push-aside-content-container">
  <ng-content></ng-content>
</div>

